import type { IconNode } from '../types';

/**
 * @name helmet-diving
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgMTcuOWMxLjUtLjkgMi43LTIuMiAzLjQtMy45aC44Yy40IDAgLjgtLjQuOC0xVjljMC0uNi0uNC0xLS44LTFoLS44QTcuOTIgNy45MiAwIDAgMCAxNSAzLjZ2LS44YzAtLjQtLjQtLjgtMS0uOGgtNGMtLjYgMC0xIC40LTEgLjh2LjhBNy45MiA3LjkyIDAgMCAwIDQuNiA4aC0uOGMtLjQgMC0uOC40LS44IDF2NGMwIC42LjQgMSAuOCAxaC44Yy43IDEuNyAxLjkgMyAzLjQgMy45IiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTEiIHI9IjQiIC8+CiAgPHBhdGggZD0iTTggMTFoOCIgLz4KICA8cGF0aCBkPSJNMTIgN3Y4IiAvPgogIDxwYXRoIGQ9Ik02LjcgMTdjLTEgLjYtMS43IDEuMi0xLjcgMiAwIDEuNyAzLjEgMyA3IDNzNy0xLjMgNy0zYzAtLjgtLjctMS40LTEuNy0yIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/helmet-diving
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const helmetDiving: IconNode = [
  [
    'path',
    {
      d: 'M16 17.9c1.5-.9 2.7-2.2 3.4-3.9h.8c.4 0 .8-.4.8-1V9c0-.6-.4-1-.8-1h-.8A7.92 7.92 0 0 0 15 3.6v-.8c0-.4-.4-.8-1-.8h-4c-.6 0-1 .4-1 .8v.8A7.92 7.92 0 0 0 4.6 8h-.8c-.4 0-.8.4-.8 1v4c0 .6.4 1 .8 1h.8c.7 1.7 1.9 3 3.4 3.9',
      key: '1pnnz3',
    },
  ],
  ['circle', { cx: '12', cy: '11', r: '4', key: '1gt34v' }],
  ['path', { d: 'M8 11h8', key: 'vwpz6n' }],
  ['path', { d: 'M12 7v8', key: 'dueqz1' }],
  [
    'path',
    { d: 'M6.7 17c-1 .6-1.7 1.2-1.7 2 0 1.7 3.1 3 7 3s7-1.3 7-3c0-.8-.7-1.4-1.7-2', key: 'i1iqi1' },
  ],
];

export default helmetDiving;
